import Icon from "./ui/Icon";

type Props = {
  id?: number;
  name?: string;
  className?: string;
};

const categoryIcons: Record<number, string> = {
  22: "Network",
  21: "OpenBook",
  20: "Satellite",
  43: "Bank",
  42: "Home",
  19: "Pen",
  18: "Heart2",
  1:  "AirPort",
  2:  "Deal",
  3:  "Vector1",
  17: "Setting",
  16: "attribution",
};

export default function CategoryIcon({ id, className = "" }: Props) {
  const icon = id ? categoryIcons[id] : "category";

  return <Icon icon={icon} className={className} />;
}
